const NotFound = () => (
  <div id="not-found">
    <h1>404</h1>
    <p>The page you’re looking for doesn’t exist.</p>
    <a href="/" className="back-home">Go back home</a>
  </div>
);

export default NotFound;
